// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__q3UQI","Item_Pesquisa":"estilo_Item_Pesquisa__RmL4j"};